import React, {useState} from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import { ImageSubmission} from "../../../../../api/ApiTypes.ts";
import {ImageDisplay} from "../../image/ImageDisplay.tsx";
import {FullSizeImageModal} from "../../image/FullSizeImageModal.tsx";
import {FormLabel} from "../../sharedStyles.tsx";



const StaticRepairImagesRenderer: React.FC<StaticFieldDisplayProps> = ({ component, value }) => {
    const imageArray = Array.isArray(value) ? value : [];
    const repairImages = imageArray.slice().reverse().filter((img: ImageSubmission) => img.showsRepair);
    const [selectedModalImage, setSelectedModalImage] = useState<ImageSubmission | null>(null);

    return (
        <>
            <FormLabel component={component}/>

            <div className="w-full aspect-[3:2] bg-gray-200 shadow-md border-1 border-gray-200 rounded-md overflow-x-auto">
                <div className="flex gap-2 p-1 h-fit">
                    {repairImages.length > 0 ?
                        repairImages.map((image) => (
                            <button
                                type="button"
                                key={image.generalFileId}
                                className="relative h-36 w-36 flex-shrink-0 border-gray-400 border-1 bg-gray-600"
                                onClick={() => setSelectedModalImage(image)}
                            >
                                <ImageDisplay image={image}/>
                            </button>
                        ))
                        : <div className="flex items-center justify-center w-full">
                            <span className="text-gray-500">No images.</span>
                        </div>
                    }
                </div>
            </div>

            <FullSizeImageModal selectedModalImage={selectedModalImage} onClose={() => setSelectedModalImage(null)} />
        </>
    );
};
export const StaticRepairImages = React.memo(StaticRepairImagesRenderer);